import Axios, { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios';
import { baseUrl } from '@/config';
import router from '@/router';
import store from '@/store';

class _CommonServices {
    baseUrl = baseUrl;

    showSpinner(){
        store.state.showSpinner++;
    };
    hideSpinner(){
        store.state.showSpinner--;
    };

    unauthorizedCb = () => {};
    
    private axios: AxiosInstance;
    defaultGet<T = any>(url: string, params?: any, _showSpinner = true, responseType: ResponseType = 'json'): Promise<T> {
        url = replaceUrl(url, params);

        const req: AxiosRequestConfig = {
            params,
            paramsSerializer: (params) => this.parseParams(params),
            responseType,
        }
        if(_showSpinner)
            this.showSpinner();
        let prom = new Promise<T>((resolve, reject) => {
            this.axios.get<T>(url, req)
            .then(x => {
                resolve(x.data);
            }).catch( err => {
                reject(err);
            })
            .finally( () => {
                if(_showSpinner)
                    this.hideSpinner();
            });
        });
        return prom;
    }
    defaultPost<T = any>(url: string,
        data?: any,
        config?: AxiosRequestConfig,
        _showSpinner = true,
        responseType: ResponseType = 'json'): Promise<T> {

        if(_showSpinner)
            this.showSpinner()

        if (config) config.responseType = responseType

        let prom = new Promise<T>((resolve, reject) => {
            this.axios.post(url, data, config).then(x => {
                resolve(x.data);
            }).catch( err => {
                reject(err);
            })
            .finally( () => {
                if(_showSpinner)
                    this.hideSpinner();
            });
        });
        return prom;
    }

    defaultDelete<T = any>(url: string, params?: any, _showSpinner = true, responseType: ResponseType = 'json'): Promise<T> {
        url = replaceUrl(url, params);

        const req: AxiosRequestConfig = {
            params,
            paramsSerializer: (params) => this.parseParams(params),
            responseType,
        }
        if(_showSpinner)
            this.showSpinner();
        let prom = new Promise<T>((resolve, reject) => {
            this.axios.delete<T>(url, req)
            .then(x => {
                resolve(x.data);
            }).catch( err => {
                reject(err);
            })
            .finally( () => {
                if(_showSpinner)
                    this.hideSpinner();
            });
        });
        return prom;
    }

    uploadFileToUrl<T = any>(url: string,
        file: File | string,
        params: { [key: string]: any },
        onUploadProgress?: ((progress: number) => void) | null,
        _showSpinner = true,
        responseType: ResponseType = 'json'
    ): Promise<T> {
        var data = new FormData();
        if (params) {
            for (var key in params) {
                data.append(key, params[key]);
            }
        }
        data.append('file', file);
        var config = {
            onUploadProgress: function (ev: any) {
                if(typeof onUploadProgress == 'function')
                    onUploadProgress((100 * ev.loaded) / ev.total);
            },
          responseType: responseType,
        };
        if(_showSpinner)
            this.showSpinner();
        let prom = new Promise<T>((resolve, reject) => {
            return this.axios.post<T>(url, data, config).then(x => {
                this.hideSpinner();
                resolve(x.data);
            })
            .catch( err => {
                this.hideSpinner();
                reject(err);
            });
        });
        return prom;
    }

    setAuthToken(token: string) {
        this.axios.defaults.headers.common['Authorization'] = "Bearer " + token;
        window.localStorage.setItem('__token', token);
    }
    getAuthToken() {
        return window.localStorage.getItem('__token');
    }
    destroyToken() {
        this.axios.defaults.headers.common['Authorization'] = "";
        window.localStorage.removeItem('__token');
    }
    setLanguage(lang: string) {
        this.axios.defaults.headers.common['Accept-Language'] = lang;
    }

    parseParams(params: any) {
        let options = ''

        for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            for (const element of value) {
            options += `${key}=${element}&`
            }
        } else if (value) {
            options += `${key}=${value}&`
        }
        }

        return options.slice(0, -1)
    }

    constructor() {
        this.axios = Axios;
        let token = window.localStorage.getItem('__token');
        this.axios.interceptors.response.use(function (response: any) {
            return response;
        }, function (error) {
            if (error.response && error.response.status == 401) {
                // Single source of truth for handling an expired/absent session:
                // send the user to login (unless they are already on a public page)
                // and remember where they were headed so login can send them back.
                const current = router.currentRoute.value;
                const publicRouteNames = [
                    'login', 'registrati', 'reset_password', 'change_password',
                    'confirm_email', 'family_invitation', 'maintenance',
                ];
                const onPublicRoute = current.path == '/' || publicRouteNames.indexOf(current.name as string) !== -1;
                if (!onPublicRoute) {
                    router.push({ path: '/', query: { redirect: current.fullPath } });
                }
                // reject anyway: a resolved-with-undefined response would hide the failure from callers
            }
            if(error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
        if (token){
            this.setAuthToken(token);
        }
    }
}

function replaceUrl(url: string, params?: any): string {

    if(!params || url.indexOf("{") == -1)
        return url;

    var beginIndex = url.indexOf("{");
    var endIndex = url.indexOf("}");

    var property = url.substring(beginIndex + 1, endIndex);
    var value = params[property];

    url = url.substring(0, beginIndex) + value + url.substr(endIndex + 1);
    delete params[property];

    return replaceUrl(url, params);
}

export let CommonServices = new _CommonServices();